import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import {
  GET_VENDOR_SUPPORT_TICKETS_REQUEST,
  GET_VENDOR_TICKET_STATUS_REQUEST,
  GET_VENDOR_TICKET_STORES_REQUEST,
  GET_VENDOR_TICKET_CONVERSATION_REQUEST,
  GET_VENDOR_TICKET_COMMENTS_REQUEST,
  SHARE_VENDOR_TICKET_REQUEST,
  UPDATE_VENDOR_TICKET_REQUEST,
} from "./type";
import {
  getVendorSupportTicketsSuccess,
  getVendorTicketStatusSuccess,
  getVendorTicketStoresSuccess,
  getVendorTicketConversationSuccess,
  getVendorTicketCommentsSuccess,
  shareVendorTicketSuccess,
  shareVendorTicketFailure,
  updateVendorTicketSuccess,
  updateVendorTicketFailure,
} from "./action";
import { handleApiCallException } from "../../shared/action";
import { invokeApi } from "../../../helper/axiosHelper";


function* getVendorSupportTickets({ payload: data }) {
  try {
    const response = yield call(
      invokeApi,
      "post",
      "/vendorSupportTicketList",
      data,
      {},
      "vendor"
    );
    if (response.status) {
      yield put(getVendorSupportTicketsSuccess(response.data));
    } else {
      yield put(getVendorSupportTicketsSuccess(null));
      handleApiCallException(response.message);
    }
  } catch (error) {
    handleApiCallException(error);
  }
}

function* getVendorTicketStatus() {
  try {
    const response = yield call(
      invokeApi,
      "post",
      "/vendorTicketStatusList",
      {},
      {},
      "vendor"
    );
    if (response.status) {
      yield put(getVendorTicketStatusSuccess(response.data));
    } else {
      handleApiCallException(response.message);
    }
  } catch (error) {
    handleApiCallException(error);
  }
}

function* getVendorTicketStores() {
  try {
    const response = yield call(
      invokeApi,
      "post",
      "/vendorTicketStoreList",
      {},
      {},
      "vendor"
    );
    if (response.status) {
      yield put(getVendorTicketStoresSuccess(response.data));
    } else {
      handleApiCallException(response.message);
    }
  } catch (error) {
    handleApiCallException(error);
  }
}


function* getVendorTicketConversation({ payload: data }) {
  try {
    const response = yield call(
      invokeApi,
      "post",
      "/vendorTicketConversation",
      data,
      {},
      "vendor"
    );
    if (response.status) {
      yield put(
        getVendorTicketConversationSuccess({
          ticketId: data?.ticketId,
          list: response.data?.list || [],
        })
      );
    } else {
      
      yield put(
        getVendorTicketConversationSuccess({ ticketId: data?.ticketId, list: [] })
      );
    }
  } catch (error) {
    handleApiCallException(error);
  }
}


function* getVendorTicketComments({ payload: data }) {
  try {
    const response = yield call(
      invokeApi,
      "post",
      "/vendorTicketComments",
      data,
      {},
      "vendor"
    );
    /* an empty list keeps the activity trail readable - it just shows the
       ticket's own milestones rather than sitting on a spinner */
    yield put(
      getVendorTicketCommentsSuccess({
        list: response.status ? response.data?.list || [] : [],
      })
    );
  } catch (error) {
    yield put(getVendorTicketCommentsSuccess({ list: [] }));
    handleApiCallException(error);
  }
}

function* shareVendorTicket({ payload: data }) {
  try {
    const response = yield call(
      invokeApi,
      "post",
      "/vendorShareTicket",
      data,
      {},
      "vendor"
    );
    if (response.status) {
      yield put(shareVendorTicketSuccess(response));
    } else {
      yield put(shareVendorTicketFailure(response));
    }
  } catch (error) {
    yield put(shareVendorTicketFailure(null));
    handleApiCallException(error);
  }
}

export 
function* updateVendorTicket({ payload: data }) {
  try {
    const response = yield call(
      invokeApi,
      "post",
      "/vendorTicketUpdate",
      data?.formData || data,
      {},
      "vendor"
    );
    if (response.status) {
      yield put(updateVendorTicketSuccess(response));
    } else {
      yield put(updateVendorTicketFailure(response));
    }
  } catch (error) {
    yield put(updateVendorTicketFailure(null));
    handleApiCallException(error);
  }
}

function* watchVendorSupportTickets() {
  yield takeLatest(GET_VENDOR_SUPPORT_TICKETS_REQUEST, getVendorSupportTickets);
  yield takeLatest(GET_VENDOR_TICKET_STATUS_REQUEST, getVendorTicketStatus);
  yield takeLatest(GET_VENDOR_TICKET_STORES_REQUEST, getVendorTicketStores);
  yield takeLatest(
    GET_VENDOR_TICKET_CONVERSATION_REQUEST,
    getVendorTicketConversation
  );
  yield takeLatest(GET_VENDOR_TICKET_COMMENTS_REQUEST, getVendorTicketComments);
  yield takeLatest(SHARE_VENDOR_TICKET_REQUEST, shareVendorTicket);
  yield takeLatest(UPDATE_VENDOR_TICKET_REQUEST, updateVendorTicket);
}

function* VendorSupportTicketsSaga() {
  yield all([fork(watchVendorSupportTickets)]);
}

export default VendorSupportTicketsSaga;
